import React, { Component } from 'react'

export const EventRecapDataContext = React.createContext()

class EventRecapDataProvider extends Component {


  state = {
    eventRecapData: { galleryImages: [], ctaList: [], videoList: [], locationList: [], vehicleList: [], additionalFields: [] }
  }

  // Method to update state
  setCurrentEventRecapData = (EventRecapData) => {
    this.setState((prevState) => ({ EventRecapData }))
  }

  render() {
    const { children } = this.props
    const { eventRecapData } = this.state
    const { setCurrentEventRecapData } = this

    return (
      <EventRecapDataContext.Provider
        value={{
          eventRecapData,
          setCurrentEventRecapData,
        }}
      >
        {children}
      </EventRecapDataContext.Provider>
    )
  }
}

// export default EventRecapDataContext

export { EventRecapDataProvider }